import React from 'react';
import TidbitIcon from '../../../../assets/images/tidbit-icon.png';

import './insight.component.css';

const Insight = (props) => {
  const getInsight = (insight) => {
    if (Array.isArray(insight)) {
      return insight.map((value) => {
        if (Array.isArray(value)) {
          return (
            <React.Fragment key={value.join(', ')}>
              <b>&nbsp;{value.join(', ')}</b>.
              <br />
            </React.Fragment>
          );
        } else {
          return value;
        }
      });
    } else {
      return insight;
    }
  };

  return (
    <div className="insight p-3">
      <div className="insight-icon mr-3">
        <img src={TidbitIcon} alt="insight-icon" />
      </div>
      <div>{getInsight(props.insight)}</div>
    </div>
  );
};

export default Insight;
